import { createContext } from "react";

export const ImageAddressContext = createContext(null);